<app-activity
  *ngIf="id"
  [model]="'entities/expats'"
  [modelId]="id"
></app-activity>
